import * as Sentry from '@sentry/browser';
import { initializeGame } from '@config/baseInitializer';

// Initialize Sentry for error tracking
if (process.env.SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    environment: process.env.NODE_ENV || 'production',
  });
}

let gameInitialized = false;

/**
 * Loads and initializes the game.
 * @param {Object} [gameState] - Initial game state passed through to scenes
 */
function loadGame(gameState = {}) {
  if (gameInitialized) {
    console.warn('[GAME] Game already initialized, ignoring duplicate request');
    return;
  }
  gameInitialized = true;

  const hostname = window.location.hostname;
  window.isLocalHost =
    hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '';

  console.info('[GAME] Initializing game');
  const game = initializeGame(gameState);

  const refreshScale = () => requestAnimationFrame(() => game.scale.refresh());
  if (document.readyState === 'complete') {
    refreshScale();
  } else {
    window.addEventListener('load', refreshScale, { once: true });
  }
}

loadGame({});
